import { render } from "./Send.vue?vue&type=template&id=564eadce&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"

import "@/assets/css/Balances.css?vue&type=style&index=0&id=564eadce&scoped=true&lang=css&external"
import "./Send.vue?vue&type=style&index=1&id=564eadce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564eadce"]])

export default __exports__